import { useCallback, useEffect, useMemo, useState } from "react";
import useHttpErrorHandler from "../../../hooks/useHttpErrorHandler";
import * as Api from "./api";
import { IRemyndBrandPartnerMapFullData } from "./types";
import { convertListToDropdownOptions } from "./utils";

export type FullDataState = Readonly<{
  fetching: boolean;
  data?: IRemyndBrandPartnerMapFullData;
}>;

export const useFullData = (partnerId?: PartnerId) => {
  const { handleError } = useHttpErrorHandler();
  const [state, setState] = useState<FullDataState>({ fetching: false });

  const fetchFullData = useCallback(async () => {
    setState(d => ({ ...d, fetching: true }));
    if (partnerId) {
      try {
        const resp = await Api.listFullData(partnerId);
        setState({ fetching: false, data: resp.value });
      } catch (e) {
        handleError(e);
        setState({ fetching: false, data: undefined });
      }
    } else {
      setState({ fetching: false, data: undefined });
    }
  }, [partnerId, handleError]);

  useEffect(() => {
    fetchFullData();
  }, [fetchFullData]);

  const dropdowns = useMemo(
    () =>
      state.data ? convertListToDropdownOptions(state.data.remyndBrands) : [],
    [state.data]
  );

  return {
    state,
    fetchFullData,
    dropdowns
  };
};
